@import ../../styles/helpers

.input_container
    position: relative
    button
        position: absolute
        top: 50%
        transform: translateY(-50%)
        right: 10px
        color: white

.form__input
    width: 100%
    height: 48px
    padding: 0 14px 0 14px
    border-radius: 12px
    background: none
    border: 2px solid $neutrals6
    +snappy
    color: $neutrals2
    transition: border-color .2s
    +dark
        border-color: $neutrals3
        color: $neutrals8
    +placeholder
        color: $neutrals4
    &:focus
        border-color: $neutrals4